module.exports = __webpack_public_path__ + "static/media/assitance.209118bc.svg";